// extracted by mini-css-extract-plugin
module.exports = {"CommonFooter":"CommonFooter_CommonFooter__3quhP"};